<!--
 * @Author: zhouhx
 * @Date: 2022-08-18 18:20:42
 * @LastEditors: zhouhx
 * @LastEditTime: 2024-05-17 14:56:48
 * @Description:
-->
<template>
  <div class="report">
    <van-nav-bar title="会诊报告" left-arrow @click-left="$router.go(-1)"></van-nav-bar>
    <div class="wrap">
      <header class="border-bottom-1px">
        <div class="logo">
          <img :src="imgUrl" :onerror='defaultImg' />
        </div>
        <div class="info">
          <div class="title">{{ reportInfo.report.title }}</div>
          <div class="des">{{ reportInfo.report.smallTitle }}</div>
        </div>
      </header>
      <content>
        <ul class="Relevant border-bottom-1px">
          <li>
            <span class="left">会诊号：</span>
            <span class="value">{{ reportInfo.id }}</span>
          </li>
          <li style="flex-basis: 100%;float:none">
            <span class="left">会诊时间：</span>
            <span class="value">{{ reportInfo.consultSignTime }}</span>
          </li>
          <li>
            <span class="left">姓名：</span>
            <span class="value">{{ reportInfo.patientName }}</span>
          </li>
          <li>
            <span class="left">性别：</span>
            <span class="value">{{ reportInfo.patientGender }}</span>
          </li>
          <li>
            <span class="left">年龄：</span>
            <span class="value">{{ reportInfo.patientAge }}</span>
          </li>
          <li style="flex-basis: 100%;float:none">
            <span class="left">申请医生：</span>
            <span class="value">{{ reportInfo.creatorName }}</span>
          </li>
          <li style="flex-basis: 100%;float:none">
            <span class="left">申请机构：</span>
            <span class="value">{{ reportInfo.organizationName }}</span>
          </li>
          <li style="flex-basis: 100%;float:none">
            <span class="left">申请日期：</span>
            <span class="value">{{ reportInfo.applyTime }}</span>
          </li>
        </ul>
        <div class="consult-option border-bottom-1px">
          <div class="optiondiv" v-for="(item, index) in reportInfo.report.ReportBlocks" :key="index">
            <div v-if="item.dataElementName.indexOf('附件') === -1">
              <div class="option">
                <span class="icon"></span>{{item.dataElementName}}：
              </div>
              <span class="optionSpan" v-if="item.dtType === 0">
                <span class="consultrecord">{{item.dataValue}}</span>
              </span>
              <div class="img-wrap" v-if="item.dataElementName.indexOf('截图') !== -1">
                <span v-for="(item2, index2) in modal.screenshotLocal" :key="index2">
                  <img v-if="item2.checked" :src="item2.screenshotUrl" />
                </span>
                <span v-for="(item2, index2) in modal.screenshot" :key="index2">
                  <img v-if="item2.checked" :src="item2.screenshotUrl" />
                </span>
              </div>
              <span class="optionSpan" v-else-if="item.dtType === 2">
                <span v-if="item.dataElementName.indexOf('建议转诊') !== -1">
                  <span style="margin: 0" v-if="item.dataValue === '是'">建议转诊</span>
                  <span v-else style="margin: 0">不建议转诊</span>
                </span>
                <div class="optiondiv" v-if="item.dataElementName.indexOf('建议转诊') !== -1 && item.dataValue === '是'">
                  <div class="option">
                    <span class="icon"></span>转诊科室：
                  </div>
                  <span class="optionSpan">
                    <span class="consultrecord">{{modal.dptName}}</span>
                  </span>
                </div>
              </span>
              <span class="optionSpan" v-if="item.dtType === 3">
                <span class="consultrecord">{{item.dataValue}}</span>
              </span>
              <span class="optionSpan" v-if="item.dataElementName.indexOf('病情') !== -1">
                <span class="consultrecord">{{item.dataValue}}</span>
              </span>
            </div>
          </div>
          <div style="float: right">
            <span>审核专家签名：</span>
            <img v-if="reportInfo.hostSignature" :src="reportInfo.hostSignature_url"
              style="max-width: 90px;vertical-align: middle;" />
            <span v-else style="font-size:14px;">{{ reportInfo.hostName }}</span>
          </div>
        </div>
        <footer>
          <span>注：根据《关于推进医疗机构远程医疗服务的意见》国卫医发〔2014〕51号:“邀请方具有患者医学处置权，
            根据患者临床资料，参考受邀方的诊疗意见作出诊断与治疗决定。”本报告仅对送检数字切片负责，供申请医生参考。</span>
        </footer>
      </content>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activeCode: Number(this.$store.state.role.split('&')[0]),
      caseid: Number(this.$route.query.caseid),
      imgUrl: '',
      defaultImg: 'this.src="' + require('../../../../assets/default_logo.png') + '"',
      reportInfo: {
        report: {
          reportBlocks: []
        }
      },
      modal: {
        screenshotLocal: [],
        screenshot: [],
        fileList: [],
        previewImgList: [],
        dptName: ''
      },
      cntH: ''
    };
  },
  created () {
    this.getreportInfo();
  },
  methods: {
    getreportInfo () {
      this.$axios
        .post('case/consult/report/preview', {
          data: {
            caseId: this.caseid
          },
          version: this.$version
        })
        .then((res) => {
          if (res.status) {
            if (!res.data.report) {
              this.$$toast('请配置报告模板!');
              return;
            }
            // 处理逻辑
            this.handleRoleData(res);
            // res.data.report = JSON.parse(res.data.report);
            // // console.log(JSON.stringify(res.data.report))
            // res.data.consultTimeDetail = res.data.consultTime.split(':')[0] + ':' + res.data.consultTime.split(':')[1]
            // res.data.applyTimeDetail = res.data.applyTime.split(':')[0] + ':' + res.data.applyTime.split(':')[1]
            // this.reportInfo = res.data;
            // // // 处理数据
            // this.handledata(res.data.report.ReportBlocks);
          }
        });
    },
    handleRoleDataInit (res) {
      res.data.report = JSON.parse(res.data.report);
      this.reportInfo = res.data;
      // 报告logo
      if (res.data.organizationReportLogo) {
        this.imgUrl = this.utils.mixedFileUrl(res.data.organizationReportLogo);
      } else {
        this.imgUrl = this.dfsUrl + res.data.logo;
      }
      // 专家签名
      if (res.data.hostSignature) {
        if (res.data.hostSignature.includes('group1')) {
          res.data.hostSignature_url = this.utils.mixedFileUrl(
            res.data.hostSignature
          );
        } else {
          res.data.hostSignature_url = this.utils.getFileUrl(
            Number(res.data.hostSignature)
          );
        }
      }
    },
    handleRoleData (res) {
      this.handleRoleDataInit(res);
      if (res.data.organizationReportLogo) {
        this.imgUrl = this.utils.mixedFileUrl(res.data.organizationReportLogo);
      } else {
        this.imgUrl = this.dfsUrl + res.data.logo;
      }
      if (res.data.hostSignature) {
        if (res.data.hostSignature.includes('group1')) {
          res.data.hostSignature_url = this.utils.mixedFileUrl(
            res.data.hostSignature
          );
        } else {
          res.data.hostSignature_url = this.utils.getFileUrl(
            Number(res.data.hostSignature)
          );
        }
      }
      // 附件
      // if (this.reportInfo.attachments && this.reportInfo.attachments.length) {
      //   this.reportInfo.attachments.forEach((element1) => {
      //     if (element1.originName.split('.')[1].toLowerCase().includes('pdf')) {
      //       element1.fileTypes = 'pdf';
      //       element1.imgsrc = require('@/assets/img/ic_meeting.png');
      //       element1.downloadUrl =
      //         this.baseUrl +
      //         'file//download/pdf?fileId=' +
      //         Number(element1.fileId);
      //     } else {
      //       element1.fileTypes = 'img';
      //       element1.imgsrc = this.utils.getFileUrl(element1.fileId);
      //     }
      //   });
      // }
      // 本地截图
      if (this.reportInfo.localImg && this.reportInfo.localImg.length) {
        this.reportInfo.localImg.forEach((element) => {
          element.checked = false;
          element.screenshotUrl = this.utils.getFileUrl(element.fileId);
          if (element.screenShotChecked) {
            element.checked = true;
          }
        });
        this.modal.screenshotLocal = this.reportInfo.localImg;
      }
      // 病理截图
      if (this.reportInfo.pathlogImg && this.reportInfo.pathlogImg.length) {
        this.reportInfo.pathlogImg.forEach((element) => {
          element.checked = false;
          // 新病理
          if (element.fileType === 6) {
            element.screenshotUrl = this.utils.getFileUrl(element.fileId);
          } else {
            // 老病理
            element.screenshotUrl =
              ehrUrl + 'Gallery/ImagePath2/' + +Number(element.fileId);
          }
          if (element.screenShotChecked) {
            element.checked = true;
          }
        });
        this.modal.screenshot = this.reportInfo.pathlogImg;
      }
      this.reportInfo.report.ReportBlocks.forEach((element) => {
        if (element.dtType === 2) {
          if (element.subDataValue) {
            this.modal.dptName = element.subDataValue.split('0x000f')[1];
          }
        }
        if (element.dtType === 3) {
          if (element.dataValue) {
            const diseaseList = element.dataValue.split('0x000a');
            diseaseList.forEach((element2, key) => {
              // element.dataElementName = element2.split('0x000f');
              if (key !== 0) {
                element.dataValue += '、' + element2.split('0x000f')[1];
              } else {
                element.dataValue = element2.split('0x000f')[1];
              }
            });
          }
        }
      });
    }
    // handledata (data) {
    //   const resultjson = this.utils.handleOptionData(data, 3);
    //   this.modal.screenshotLocal = resultjson.localshot;
    //   this.modal.screenshot = resultjson.blshot;
    //   this.modal.fileList = resultjson.localfile;
    //   if (resultjson.dptId) {
    //     this.modal.dptName = resultjson.dptName;
    //   }
    // }
  }
};
</script>
<style lang="scss" scoped>
.consultrecord {
  white-space: break-spaces;
  word-break: break-all;
}

.border-bottom-1px {
  position: relative;
}

.report {
  min-height: calc(100vh - 52px);
  background: $white;
  position: relative;
  z-index: 1;
}

.wrap {
  width: 100%;
  padding: 0 15px;
  position: fixed;
  top: 52px;
  bottom: 0;
  overflow: auto;

  header {
    display: flex;
    height: 60px;
    margin: 10px 0;

    .logo {
      flex-basis: 60px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .info {
      flex: 1;
      display: flex;
      flex-direction: column;
      text-align: center;
      justify-content: center;
      line-height: 30px;
      padding-right: 50px;

      .title {
        font-weight: bold;
        font-size: 16px;
      }

      .des {
        color: $grey;
      }
    }
  }

  content {
    display: flex;
    flex-direction: column;
    word-wrap: break-word;

    .Relevant {
      display: flex;
      flex-wrap: wrap;
      padding: 10px 0;
      box-sizing: border-box;

      li {
        display: flex;
        padding: 10px 0;
        flex-basis: 50%;

        span {
          white-space: break-spaces;
        }

        .left {
          font-weight: bold;
        }

        .value80 {
          width: 82px;
        }
      }
    }

    .checkInfo {
      margin-top: 10px;

      li {
        width: 100%;
        display: inline-block;

        .title {
          margin-bottom: 10px;
          font-weight: bold;

          .icon {
            width: 10px;
            height: 10px;
            border-radius: 2px;
            background-color: $black;
            display: inline-block;
            margin: 0 5px;
          }
        }

        .block {
          width: 100%;
          display: flex;
          margin-bottom: 10px;
          line-height: 20px;

          span:first-child {
            margin-right: 10px;
            flex-basis: 70px;
            text-align: right;
          }

          span:last-child {
            flex: 1;
          }
        }
      }
    }

    .consult-option {
      min-height: calc(100vh - 335px);
      margin-bottom: 10px;
      padding-bottom: 35px;
      position: relative;

      .optiondiv {
        clear: both;
      }

      .option {
        padding: 15px 0;
        font-weight: bold;

        .icon {
          width: 10px;
          height: 10px;
          border-radius: 2px;
          background-color: $black;
          display: inline-block;
          margin: 0 5px;
        }
      }

      p {
        text-indent: 2em;
        line-height: 22px;
        white-space: break-spaces;
      }

      .img-wrap {
        span {
          display: inline-block;
          width: calc((100% - 20px) / 2);
          float: left;
          text-align: center;
          margin: 5px;
          height: 130px;
        }

        img {
          width: 100%;
          max-height: 100%;
        }
      }

      .autograph {
        width: 100%;
        position: absolute;
        bottom: 10px;

        span {
          float: right;
          height: 25px;
          line-height: 25px;
        }

        img {
          float: right;
          height: 25px;
        }
      }
    }
  }

  footer {
    height: 150px;
    line-height: 20px;
    color: $grey;

    span {
      font-size: 12px;
    }
  }
}
</style>
